import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@aura/components/styles'
import Box from '@aura/components/box'
import Button from '@aura/components/button'
import Typography from '@aura/components/typography'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles from './styles'


const Component = ({
    classes,
}) => {

    const { t: translate } = useTranslation()
    const history = useHistory()

    const handleBackToSignIn = useCallback(() => {
        history.push('/')
    }, [history])

    return (
        <Box className={classes.pageWrapper}>
            <Box className={classes.card}>
                <CheckCircleOutlineIcon className={classes.icon} />
                <Typography className={classes.title}>
                    {translate('requestAccess.success')}
                </Typography>
                <Typography className={classes.verbiage}>
                    {translate('requestAccess.successVerbiage1')}
                </Typography>
                <Typography className={classes.verbiage}>
                    {translate('requestAccess.successVerbiage2')}
                </Typography>
                <Divider className={classes.divider} />
                <Button
                    className={classes.button}
                    onClick={handleBackToSignIn}
                >
                    {translate('requestAccess.backToSignIn')}
                </Button>
            </Box>
        </Box>
    )
}

Component.displayName = 'RequestSuccess'

Component.defaultProps = {
    data: {
        login: ''
    }
}


Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        card: PropTypes.object,
        divider: PropTypes.object,
        icon: PropTypes.object,
        pageWrapper: PropTypes.object,
        title: PropTypes.object,
        verbiage: PropTypes.object
    }),
}

export default withStyles(Component, styles)
